export default __webpack_public_path__ + "static/media/gallery - polyjuice_00.db1fb3b5.jpg";